import { OptionsEnum } from '../../interfaces/CounterOffer';
import {
  Column,
  LabelButton,
  OptionContainer,
  OptionDescription,
  OptionSection,
  OptionSubtitle,
  OptionSubtitleSVG,
  OptionSubtitleText,
  OptionTitle,
  RadioButton,
  RadioButtonSection,
} from './OptionsStyledComponents';
import recommendSVG from '../../assets/icons/recommend.svg';
import { useEffect, useState } from 'react';
import { TextMedium } from '../../styles/GlobalStyledComponents';

interface OptionsProps {
  type: OptionsEnum;
  isSelected?: boolean;
  recommended?: boolean;
  onClick: () => void;
  dueDate?: string;
  term?: number;
  requestAmount?: string;
  installmentAmount?: string;
  firstFeeAmount?: string;
}

const Options: React.FC<OptionsProps> = ({
  type,
  isSelected,
  recommended,
  onClick,
  dueDate, // Fecha del primer vencimiento
  term, // Plazos a reducir
  requestAmount, // Importe total solicitado
  installmentAmount, // Importe de las cuotas
  firstFeeAmount, // Importe de la primera cuota (aumentado)
}) => {
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<JSX.Element | string>('');

  // Las opciones contempladas con sus 4 tipos de texto dinámico
  const getOptionTexts = () => {
    switch (type) {
      case OptionsEnum.TIR:
        setTitle('Mantener importe y plazo');
        const tirDescriptionHtml =
        <TextMedium $fontSize={12} $color="gray6">
          Con un nuevo tipo aplicado, la cuota sería de <strong>{installmentAmount}€</strong> al mes.
        </TextMedium>
        setDescription(tirDescriptionHtml);
        break;

      case OptionsEnum.TERM:
        setTitle(`Reducir plazo ${term} meses`);
        const termDescriptionHtml = 
        <TextMedium $fontSize={12} $color="gray6">
          La financiación finalizaría el <strong>{dueDate}</strong>, quedando una cuota de <strong>{installmentAmount}€</strong> al mes.
        </TextMedium>
        setDescription(termDescriptionHtml);
        break;

      case OptionsEnum.AMOUNT:
        setTitle('Reducir importe solicitado');
        const amountDescriptionHtml = 
        <TextMedium $fontSize={12} $color="gray6">
          Solicita <strong>{requestAmount}€</strong> con cuotas de <strong>{installmentAmount}€</strong> al mes.
        </TextMedium>
        setDescription(amountDescriptionHtml);
        break;

      case OptionsEnum.INSTALLMENT:
        setTitle('Modificar primera cuota');
        const installmentDescriptionHtml =
        <TextMedium $fontSize={12} $color="gray6">
          Se realizaría un primer pago hoy de <strong>{firstFeeAmount}€</strong> y se reducirían las cuotas a <strong>{installmentAmount}€</strong> al mes.
        </TextMedium>
        setDescription(installmentDescriptionHtml);
        break;
      default:
        return '';
    }
  };

  useEffect(() => {
    getOptionTexts();
  }, []);

  return (
    <OptionContainer 
      id="option-container"
      $isSelected={isSelected} 
      $isRecommended={recommended} 
      onClick={onClick}>
      <OptionSection id="option-section">
        <RadioButtonSection>
          <RadioButton type="radio" checked={isSelected} onChange={onClick} />
          <LabelButton htmlFor={type}></LabelButton>
        </RadioButtonSection>
        <Column id="option-column">
          <OptionTitle id="option-title">{title}</OptionTitle>
          {recommended && (
            <OptionSubtitle id="option-subtitle">
              <OptionSubtitleSVG src={recommendSVG} alt="recommend icon" />
              <OptionSubtitleText $fontSize={10}>¡Recomendado!</OptionSubtitleText>
            </OptionSubtitle>
          )}
          <OptionDescription id="option-description" $fontSize={12}>{description}</OptionDescription>
        </Column>
      </OptionSection>
    </OptionContainer>
  );
};

export default Options;
